import { FileUndoIcon } from './FileUndoIcon';

/**
 * author: Michael Richins
 * id 5CCC54A4-04AF-4241-80AB-177C8365A905
 * name file-undo
 * version: 2.3.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/file-undo.svg
 * tags
 * - Files / Folders 
 */
export const FileRevertIcon = FileUndoIcon;
export default FileRevertIcon